import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserDropdownComponent } from './user-dropdown.component';
import { SparkPlusDropdownModule } from '@shared/components/dropdown/dropdown.module';

@NgModule({
  declarations: [
    UserDropdownComponent
  ],
  imports: [
    CommonModule,
    SparkPlusDropdownModule
  ],
  exports: [
    UserDropdownComponent
  ]
})
export class UserDropdownModule { }
